import React, { Component } from "react";
import { Table, Tag, Button, Modal } from "antd";
import { RiFileCopyLine, RiPrinterLine } from "react-icons/ri";
import { connect } from "react-redux";
import ShippingDropDownComponentPrototype from "../ShippingDropDownComponentPrototype";
import STATUS from "../../../constants/shipping/StatusTypesNew";
import METHODS from "../../../constants/shipping/MethodTypesNew";
import { ShipmentTableHelpers } from "./ShipmentTableHelpers";

var fileDownload = require('js-file-download');
import { Storage } from "aws-amplify/lib";

const mapStateToProps = state => ({
    focusedShipment: state.shippingState.focusedShipment
});

const mapDispatchToProps = dispatch => ({
    getPickslips: (shipmentId) => dispatch(require('../../../actions/ShippingActionsNew').getPickslips(shipmentId))
});

class OpenShipmentsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            labelModalVisible: false,
            currentLabelUrl: null,
            currentShipmentId: null
        };
    }

    async handleLabelDownload(name) {
        try {
            const result = await Storage.get('labels/' + name + '-label.pdf', { download: true });
            fileDownload(result.Body, name + '-label.pdf');
        } catch (err) {
            console.error('Error downloading label:', err);
        }
    }

    handleShowLabel = async (shipmentId) => {
        try {
            const labelUrl = await Storage.get('labels/' + shipmentId + '-label.pdf');
            this.setState({
                labelModalVisible: true,
                currentLabelUrl: labelUrl,
                currentShipmentId: shipmentId
            });
        } catch (err) {
            console.error('Error loading label:', err);
        }
    }

    handleModalClose = () => {
        this.setState({
            labelModalVisible: false,
            currentLabelUrl: null,
            currentShipmentId: null
        });
    }

    isDisabled(status) {
        let disabledStatus = [
            STATUS.COMPLETE,
            STATUS.REJECTED,
            STATUS.HOLD,
            STATUS.HOLD_WEIGHT,
            STATUS.FULFILLED
        ];
        return disabledStatus.includes(status);
    }


    determinePrintType(shipmentId, isLabelPrinted, status, localLabelUrl, isSearched) {
        let labelExists = !!isLabelPrinted || status === STATUS.COMPLETE;
        let clickHandler = labelExists ?
            ((e) => {
                this.handleShowLabel(shipmentId);
                e.stopPropagation();
            }) :
            ((e) => {
                this.props.getPickslips(shipmentId);
                e.stopPropagation();
            });

        if (isSearched && localLabelUrl) {
            return (
                <div style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                    <Button 
                        type="primary"
                        onClick={clickHandler}
                    >
                        {labelExists ? 'VIEW LABEL' : 'PRINT PICKSLIP'}
                    </Button>
                    <Button 
                        type="primary"
                        onClick={(e) => {
                            this.setState({
                                labelModalVisible: true,
                                currentLabelUrl: localLabelUrl,
                                currentShipmentId: shipmentId
                            });
                            e.stopPropagation();
                        }}
                        style={{ 
                            backgroundColor: '#52c41a',
                            borderColor: '#52c41a'
                        }}
                    >
                        VIEW LABEL
                    </Button>
                </div>
            );
        }

        return (
            <Button
                type="primary"
                onClick={clickHandler}
            >
                <RiPrinterLine size={16} style={{ marginRight: '4px' }} />
                {labelExists ? 'View Label' : 'Print Pickslip'}
            </Button>
        );
    }

    buildShipmentInformation(shipment) {
        const baseInfo = ShipmentTableHelpers.buildShipmentInformation(shipment);
        return {
            ...baseInfo,
            print: this.determinePrintType(shipment.shipmentId, shipment.labelsPrinted, shipment.status, shipment.localLabelUrl, shipment.isSearched),
        };
    }

    getRowClassName = (record) => {
        return ShipmentTableHelpers.getRowClassName(record);
    };

    render() {
        const { shipments, expandedRowKeys, onExpand } = this.props;

        const columns = [
            {
                title: 'Carrier',
                dataIndex: 'carrier',
                key: 'carrier',
                width: '10%',
                render: (text, record) => ShipmentTableHelpers.renderCarrierColumn(text, record)
            },
            {
                title: 'Store',
                dataIndex: 'brand',
                key: 'brand',
                width: '12%',
                render: (text, record) => ShipmentTableHelpers.renderStoreColumn(text, record)
            },
            {
                title: 'Shipment Details',
                dataIndex: 'shipmentId',
                key: 'shipmentDetails',
                width: '25%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    const isUrgent = record.method === METHODS.CLICKCOLLECT || record.method === METHODS.SAME_DAY;
                    const shortShipmentId = text.substring(0, 13);

                    return (
                        <div>
                            <div 
                                style={{ 
                                    fontWeight: '700', 
                                    fontSize: '16px',
                                    color: isUrgent ? '#ff4d4f' : 'inherit'
                                }}
                            >
                                {shipmentInfo.carrierTitle}
                            </div>
                            <div style={{ 
                                fontWeight: '700', 
                                fontSize: '14px', 
                                textTransform: 'uppercase', 
                                color: '#666',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            }}>
                                <span style={{ userSelect: 'none' }}>SHIPMENT: </span>
                                <span style={{ userSelect: 'text' }}>{shortShipmentId}</span>
                                <button 
                                    type="button" 
                                    style={{ 
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '2px',
                                        height: '18px',
                                        width: '18px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onClick={(e) => {
                                        navigator.clipboard.writeText(shortShipmentId);
                                        e.stopPropagation();
                                    }}
                                    title="Copy shipment ID"
                                >
                                    <RiFileCopyLine size={12} />
                                </button>
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Time Since Order',
                dataIndex: 'timeSince',
                key: 'timeSince',
                width: '15%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    return shipmentInfo.timeSince;
                }
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                width: '20%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    return shipmentInfo.status;
                }
            },
            {
                title: 'Print',
                dataIndex: 'print',
                key: 'print',
                width: '15%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    return shipmentInfo.print;
                }
            }
        ];

        const expandedRowRender = (record) => {
            return this.props.renderExpandedRow(record);
        };

        return (
            <>
                <Table
                    columns={columns}
                    dataSource={shipments}
                    rowKey="shipmentId"
                    expandedRowRender={expandedRowRender}
                    onExpand={onExpand}
                    expandedRowKeys={expandedRowKeys}
                    expandRowByClick={true}
                    rowClassName={this.getRowClassName}
                    locale={{ emptyText: this.props.emptyMessage }}
                    pagination={{
                        pageSize: 100,
                        showQuickJumper: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} shipments`
                    }}
                    scroll={{ x: 1200 }}
                />
                
                <Modal
                    title={`Shipping Label - ${this.state.currentShipmentId?.substring(0, 13)}`}
                    visible={this.state.labelModalVisible}
                    onCancel={this.handleModalClose}
                    footer={[
                        <Button key="close" onClick={this.handleModalClose}>
                            Close
                        </Button>,
                        <Button 
                            key="download" 
                            type="primary" 
                            onClick={() => {
                                if (this.state.currentShipmentId) {
                                    this.handleLabelDownload(this.state.currentShipmentId);
                                }
                            }}
                        >
                            Download PDF
                        </Button>
                    ]}
                    width={800}
                    bodyStyle={{ padding: '20px', textAlign: 'center' }}
                >
                    {this.state.currentLabelUrl && (
                        <iframe
                            src={this.state.currentLabelUrl}
                            style={{ 
                                width: '100%', 
                                height: '600px', 
                                border: 'none' 
                            }}
                            title="Shipping Label"
                        />
                    )}
                </Modal>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OpenShipmentsTable);